import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventService, FormEvent, OutletEnum, RouteHelperService } from '@polygon/core';
import { filter } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ValuekeepEvents {
	private readonly eventService = inject(EventService);
	private readonly destroyRef = inject(DestroyRef);
	private readonly routeHelperService = inject(RouteHelperService);

	initialize() {
		this.eventService
			.getOnEvent()
			.pipe(
				takeUntilDestroyed(this.destroyRef),
				filter((formEvent: FormEvent) => formEvent?.key === 'listCustomReports')
			)
			.subscribe((formEvent: FormEvent) => {
				this.routeHelperService.navigate(
					undefined,
					undefined,
					'custom-reports-selection',
					{
						moduleName: formEvent.eventContext.moduleName,
						serviceName: formEvent.eventContext.serviceName,
						name: formEvent.eventContext.name,
						value: formEvent.eventContext.value
					},
					OutletEnum.Popup, 
					true,
					false,
					false
				);
			});
	}
}
